import React from 'react';
import { useLanguage, LANGUAGES } from '../../i18n/LanguageContext';
import './LanguageSwitcher.css';

const LanguageSwitcher = ({ className = '', compact = false }) => {
  const { language, setLanguage } = useLanguage();

  return (
    <div
      className={`language-switcher-pill ${compact ? 'compact' : ''} ${className}`}
      role="group"
      aria-label="Dil / Taal Seçimi"
    >
      <button
        type="button"
        className={`lang-option-btn ${language === LANGUAGES.TR ? 'active' : ''}`}
        onClick={() => setLanguage(LANGUAGES.TR)}
        title="Türkçe"
        aria-pressed={language === LANGUAGES.TR}
      >
        <span className="lang-flag" role="img" aria-label="Türkiye">🇹🇷</span>
        <span className="lang-code">TR</span>
      </button>

      <button
        type="button"
        className={`lang-option-btn ${language === LANGUAGES.NL ? 'active' : ''}`}
        onClick={() => setLanguage(LANGUAGES.NL)}
        title="Nederlands (Flemenkçe)"
        aria-pressed={language === LANGUAGES.NL}
      >
        <span className="lang-flag" role="img" aria-label="Nederland">🇳🇱</span>
        <span className="lang-code">NL</span>
      </button>
    </div>
  );
};

export default LanguageSwitcher;
